export default class Tab {
  /**
   * @type {HTMLElement}
   */
  element;

  /**
   * @type {number}
   */
  id = 0;

  /**
   * @type {boolean}
   */
  valid = false;

  /**
   * @type {boolean}
   */
  invalid = false;

  /**
   * @type {boolean}
   */
  active = false;

  /**
   * @type {boolean}
   */
  disabled = false;

  constructor(element) {
    this.element = element;
    this.id = Number(this.element.dataset.step);
    if (this.element.classList.contains('active')) this.active = true;
  }
}
